<div *ifSize="'XL'"
  class="p-b-5 b-b b-col-42">
  <div class="flex flex-justify-between flex-middle">
    <rating class="w-12"
      style="margin-left: -0.15rem;"
      [ngClass]="variant === 'standard' ? 'fs-8' : 'fs-5'"
    [value]="review.data.rating / 20"></rating>
    @if (variant === 'modal') {
      <p class="col-11 p3 no-wrap"
      >{{review.data.date | formatDate }}</p>
    }
  </div>

  @if (review.data.content) {
    <div class="w-11 w-12-s">
      <p class="p2 m-t-3"
      [ngClass]="variant === 'standard' ? 'col-1' : 'col-11'">{{review.data.content}}</p>
    </div>
  }

  @if (variant === 'standard') {
    <p class="col-12 p1 m-t-3 no-wrap"
    >{{review.data.date | formatDate }}</p>
  }
  <ng-container>

  </ng-container>

  <!-- <ng-container [ngTemplateOutlet]="reviewImages"></ng-container> -->

  <p [ngClass]="variant === 'standard' ? 'p1 col-1 m-t-2' : 'p3 col-11 m-t-3'">{{review.data.author}}</p>

  @if (review.data.replies) {
    <div
      class="p-r-3">
      @for (reply of review.data.replies; track $index) {
        <div class="w-12 m-l-3 m-t-3 p-a-3 bg-col-5"
          style="border-radius: 8px;"
          >
          <img class="m-b-1"
            src="/assets/images/lemieux-logo.svg"
            height="11">
          <p class="p3 col-1"
            style="line-height: 20px;">
          {{review.data.replies[0].message}}</p>
        </div>
      }
    </div>
  }
</div>

<div *ifSize="'MS'"
  class="p-b-4 b-b b-col-42">
  <div class="flex flex-justify-between">
    <rating [ngClass]="variant === 'standard' ? 'fs-9 p-r' : 'fs-5'"
      [value]="review.data.rating / 20"
    style="margin-left: -0.15rem;"></rating>
    <p class="no-wrap"
      [ngClass]="variant === 'standard' ? 'p2 col-12' : 'p3 col-11'">{{review.data.date |
    formatDate }}</p>
  </div>

  <div class="m-t-3"
  [ngClass]="variant === 'standard' ? 'h4' : 'p2 col-11'">{{review.data.title}}</div>

  <read-more class="block p2 m-t-3"
    [ngClass]="variant === 'standard' ? 'col-1' : 'col-11'"
    text="{{review.data.content}}"
    [hideDots]="true"
  limit="150"></read-more>

  <!-- <ng-container [ngTemplateOutlet]="reviewImages"></ng-container> -->

  <p class="m-t-3"
  [ngClass]="variant === 'standard' ? 'p1' : 'p3 col-11'">{{review.data.author}}</p>

  @if (review.data.replies) {
    <div
      class="p-r-3">
      @for (reply of review.data.replies; track $index) {
        <div class="w-12 m-l-3 m-t-3 p-a-3 bg-col-5"
          style="border-radius: 8px;"
          >
          <img class="m-b-1"
            src="/assets/images/lemieux-logo.svg"
            height="11">
          <p class="p3 col-1"
            style="line-height: 20px;">
          {{review.data.replies[0].message}}</p>
        </div>
      }
    </div>
  }
</div>

<!-- <ng-container *ngIf="review.data.images?.length">
<photoswipe-lightbox class="_photoswipe"
  [photoswipeOptions]="photoswipeOptions">
  <ng-template #photoswipeThumbnailTpl
    let-item
    let-i="index"
    let-photoswipe="photoswipe">
    <div class="pos-relative bg-col-5 pswp__thumb"
      *ngIf="item.source"
      [class.is-active]="item === photoswipe?.currItem"
      (click)="photoswipe?.goTo(i)">
      <img [style.height.rem]="4"
        [image]="item.source">
    </div>
  </ng-template>

  <ng-template #photoswipeIconCloseTpl>
    <div class="col-12 flex flex-middle">
      <i class="icon-chevron inline-flex rotate-180 va-m"
        [style.fontSize.rem]="1.5"
      aria-hidden="true"></i>
      <span class="inline-block m-l-1 overflow-hidden p1 no-wrap"
        [style.marginTop.px]="2">{{'Close zoom' |
      translate}}</span>
    </div>
  </ng-template>

  <ng-template #photoswipeIconPrevTpl></ng-template>

  <ng-template #photoswipeIconNextTpl></ng-template>
</photoswipe-lightbox>
</ng-container>

<ng-template #reviewImages>
  <div *ngIf="review.data.images"
    class="flex m-t-3 w-12 flex-wrap"
    [style.gap.px]="12">
    <img *ngFor="let image of review.data.images; index as index"
      [style.height.px]="100"
      class="_cursor"
      [image]="image.url"
      [photoswipe]="image.url"
      [photoswipeUid]="image.feefo_media_id"
             [photoswipeOptions]="{
                                        index: index,
                                        galleryUID: 'photoswiperReviews_' + review.data.id
                                    }">
  </div>
</ng-template> -->